import { useRouter } from "next/router"
import { Button } from "@components/anti/Button"
import { Image } from "@components/anti/Image"
import Link from "@components/anti/Link"
import { translations } from "src/helper/translations"
import { useScrollAnim } from "src/hooks/hooks"

function GovernancePdfItem({ className, title, date, linkPdf }) {
  const router = useRouter()
  return (
    <div
      className={`governance-pdf-item ${className}`}
      // onClick={() => window.open(linkPdf, "_blank")}
      role="presentation"
    >
      <div className="row w-100">
        <div className="col-3 col-lg-1 col-img">
          <Image
            src="/img/icon/img_icon-pdf.png"
            width={64}
            height={64}
            alt="pdf-icon"
            className="governance-pdf-item__icon"
          />
        </div>
        <div className="col-9 col-lg-7 col-text">
          <Link href={linkPdf} target="_blank">
            <h6 className="governance-pdf-item__title">{title}</h6>
          </Link>
          <p className="governance-pdf-item__date">{date}</p>
        </div>
        <div className="col-12 col-lg-4 col-btn">
          <Button
            variant="outline-primary"
            link={`/api/download?url=${linkPdf}&title=${title}`}
            target="_blank"
            className="w-100 w-lg-auto mt-3 mt-lg-0"
          >
            Download
          </Button>
        </div>
      </div>
    </div>
  )
}

export default GovernancePdfItem
